import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'

const RespRate = ({value, onChange}) => (
    <Grid item xs={12} md={6} lg={4} xl={3}>
          <SimpleTextField
            type="number"
            value={value}
            onChange={onChange}
            label="Respiratory Rate"
            InputProps={{
              inputProps: { min: 0, max: 999, step: 'any' },
            }}
          />
        </Grid>
)

export default RespRate